// `www.` and the bare apex name one site; other subdomains stay distinct. Mirrored by App\Support\SiteHostname.
const siteHostname = (hostname) => hostname.replace(/^www\./, '')

export const matchesUrlCriteria = (criteria, fullUrl) => {
  const url = new URL(fullUrl)

  const { domain, operator } = criteria
  const targetDomain = operator && typeof domain === 'string' ? domain.toLowerCase() : domain
  if (
    targetDomain !== '*' &&
    (typeof targetDomain !== 'string' || siteHostname(targetDomain) !== siteHostname(url.hostname))
  ) {
    return false
  }

  const normalizePath = (path) => path.replace(/^\/+|\/+$/g, '').toLowerCase()

  let urlPath = normalizePath(url.pathname)
  let criteriaPath = normalizePath(criteria.path)

  if (operator) {
    if (
      (operator === 'contains' || operator === 'does not contain') &&
      criteria.path.startsWith('/') &&
      criteria.path.endsWith('/')
    ) {
      urlPath = url.pathname.toLowerCase()
      if (!urlPath.startsWith('/')) {
        urlPath = '/' + urlPath
      }
      criteriaPath = criteria.path.toLowerCase()
    }
    switch (operator) {
      case 'equals':
        return urlPath === criteriaPath
      case 'does not equal':
        return urlPath !== criteriaPath
      case 'contains':
        return urlPath.includes(criteriaPath)
      case 'does not contain':
        return !urlPath.includes(criteriaPath)
      case 'starts with':
        return urlPath.startsWith(criteriaPath)
      case 'ends with':
        return urlPath.endsWith(criteriaPath)
      case 'glob':
        return new RegExp(
          '^' + criteriaPath.replace(/[.*+?^${}()|[\]\\]/g, (char) => (char === '*' ? '.*' : '\\' + char)) + '$'
        ).test(urlPath)
      default:
        return false
    }
  }

  if (criteriaPath.includes('*')) {
    const pathRegex = new RegExp('^' + criteriaPath.replace('*', '.*') + '$')
    return pathRegex.test(urlPath)
  }
  return criteriaPath === urlPath
}
